<template>
  <div>
    <v-card>
      <v-system-bar dark color="grey darken-1" height="50">
        <v-btn
          outlined
          small
          fab
          dark
          class="transparent"
          @click.stop="$router.go(-1)"
        >
          <v-icon>mdi-arrow-left-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        Activité : {{ etapeEffective[0].ll_etape }}
        <v-spacer></v-spacer>

        <v-btn
          outlined
          small
          fab
          dark
          class="transparent"
          @click.stop="$router.go(-1)"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-system-bar>
      <v-card-text>
        <!--      {{ etapeEffective[0] }} -->
        <v-simple-table>
          <tbody>
            <tr>
              <td>
                Campagne : {{ etapeEffective[0].ll_programme }}
                {{ etapeEffective[0].ll_parcours_effectif }}
              </td>
              <td>Nom du groupe : {{ etapeEffective[0].nom_groupe }}</td>
              <td>
                Facilitateur :
                <b>
                  <a href="#">{{ etapeEffective[0].nom_responsable }}</a></b
                >
              </td>
            </tr>
            <tr>
              <td>Etape : {{ etapeEffective[0].ll_etape }}</td>
              <td>Campagne : {{ etapeEffective[0].ll_parcours }}</td>
              <td>Projet : {{ etapeEffective[0].ll_programme }}</td>
            </tr>
          </tbody>
        </v-simple-table>
        <v-simple-table>
          <thead>
            <th>Nom</th>
            <th>Sexe</th>
            <th v-for="(etape, index) in detailEtapes" :key="index">
              {{ etape.ll_details_etapes }}
            </th>
            <th>Actions</th>
          </thead>
          <tbody>
            <tr v-for="(item, index) in MembresDuGroupe" :key="index">
              <td>{{ item.nom }}</td>
              <td>{{ getSexe(item.sexe) }}</td>
              <td v-for="(etape, index) in detailEtapes" :key="index">
                {{ etape.ll_details_etapes }}
              </td>
              <td>
                <v-btn small class="info"
                  ><v-icon>mdi-reload</v-icon> Mettre à jour</v-btn
                >
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      MembresDuGroupe: [],
      detailEtapes: [],
    };
  },
  components: {},
  mounted() {},
  created() {
    let payload = {
      IdParcoursEffectif: this.$route.query.parcoursEffectif,
      idEtape: this.$route.query.idEtape,
    };

    this.get_etape_effective_by_parcours_et_etape(payload);
    this.GetMembresDuGroupe(this.$route.query.idGroupe);
    this.GetDetailsEtape(this.$route.query.idEtape);
  },

  methods: {
    getSexe(sexe) {
      if (sexe == "1") {
        return "Masculin";
      } else {
        return "Féminin";
      }
    },
    GetMembresDuGroupe(idGroupe) {
      let self = this;
      this.$store.commit(
        "Loading/START_BUSY_STATE",
        "fiches GetMembresDuGroupe",
        {
          root: true,
        }
      );
      this.$firebase
        .firestore()
        .collection("membres")
        .where("id_groupe", "==", idGroupe)
        .orderBy("nom")
        .get()
        .then(
          (snapshot) => {
            snapshot.forEach(function (doc) {
              self.MembresDuGroupe.push({
                ...doc.data(),
                id: doc.id,
              });
            });
          },
          (error) => {
            console.log(error);
            let snackbar = {};
            snackbar.showSnackbar = true;
            snackbar.snackbarContent = error.message;
            this.$store.commit("Snackbar/SET_SNACKBAR", snackbar, {
              root: true,
            });
            this.$store.commit(
              "Loading/END_BUSY_STATE",
              "Error GetMembresDuGroupe",
              {
                root: true,
              }
            );
          }
        );
    },
    GetDetailsEtape(idEtape) {
      let self = this;
      this.$store.commit(
        "Loading/START_BUSY_STATE",
        "fiches GetMembresDuGroupe",
        {
          root: true,
        }
      );
      this.$firebase
        .firestore()
        .collection("detailEtapes")
        .where("etape_id_etape", "==", idEtape)
        .orderBy("rangDetailEtape")
        .get()
        .then(
          (snapshot) => {
            snapshot.forEach(function (doc) {
              self.detailEtapes.push({
                ...doc.data(),
                id: doc.id,
              });
            });
            console.log(self.detailEtapes);
          },
          (error) => {
            console.log(error);
            let snackbar = {};
            snackbar.showSnackbar = true;
            snackbar.snackbarContent = error.message;
            this.$store.commit("Snackbar/SET_SNACKBAR", snackbar, {
              root: true,
            });
            this.$store.commit(
              "Loading/END_BUSY_STATE",
              "Error GetMembresDuGroupe",
              {
                root: true,
              }
            );
          }
        );
    },
    ...mapActions({
      get_etape_effective_by_parcours_et_etape:
        "EtapeEffective/get_etape_effective_by_parcours_et_etape",
    }),
  },
  computed: {
    ...mapState({
      etapeEffective: (state) => state.EtapeEffective.etapeEffective,
    }),
  },
};
</script>

<style lang="scss" scoped></style>
